"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var formik_1 = require("formik");
var asg_1 = require("@alinta-digital/asg");
var PaymentDetails_1 = require("../../view/PaymentDetails");
var Message_1 = require("../Message/Message");
function EmailAddress(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.Box, { margin: { top: 'medium' }, width: "100%", maxWidth: "704px" },
            react_1.default.createElement(formik_1.Field, { name: PaymentDetails_1.SECTION_KEY + ".emailAddress", id: PaymentDetails_1.SECTION_KEY + ".emailAddress", "data-testid": PaymentDetails_1.SECTION_KEY + "-emailAddress", type: "email", label: "Your email (optional)", placeholder: "Email address", component: asg_1.FormTextInput, color: asg_1.colors['colour-black'], onClick: function () {
                    var _a, _b;
                    if (((_a = props.ga) === null || _a === void 0 ? void 0 : _a.eventName) === 'process.web.payment') {
                        (_b = props.ga) === null || _b === void 0 ? void 0 : _b.push('click.3.emailreciept');
                    }
                } })),
        react_1.default.createElement(Message_1.Message, { "data-testid": "data-Message" }, "We\u2019ll automatically send a receipt to the email listed on your account. If you'd like a copy sent to an additional email address, please enter it above.")));
}
exports.default = EmailAddress;
//# sourceMappingURL=EmailAddress.js.map